// extracted by mini-css-extract-plugin
export default {"content":"RequestNewItem_content__lE4hr"};